export default __webpack_public_path__ + "search-examples-uitextfield-search-thumbnail-480-c673e5548862c3d972651121c1acbe41.webp";